<template>
  <div class="flex flex-col flex-1 h-full">
    <div class="w-full z-10 bg-white shadow-md">
      <div
        class="mx-auto px-6 container flex flex-row space-y-3 items-end mb-5 space-x-2"
      >
        <div class="space-y-1 flex-1">
          <label
            for="searchText"
            class="block text-sm font-medium text-gray-700"
            >Search Query
          </label>
          <input
            type="text"
            name="searchText"
            id="searchText"
            placeholder="Search by a title, keyword, tag, or YouTube ID..."
            class="focus:ring-blue-500 focus:border-blue-500 block w-full pl-4 pr-4 sm:text-sm border-gray-300 rounded-md shadow-sm "
            v-model="searchQuery"
          />
        </div>
        <div class="space-y-1">
          <label
            for="searchText"
            class="block text-sm font-medium text-gray-700"
            >Date (optional)
          </label>
          <input
            type="date"
            name="startDate"
            id="searchText"
            class="focus:ring-blue-500 focus:border-blue-500 block w-full pl-4 pr-4 sm:text-sm border-gray-300 rounded-md shadow-sm "
            v-model="searchDate"
          />
        </div>

        <div class="space-y-1">
          <label
            for="searchText"
            class="block text-sm font-medium text-gray-700"
            >User
          </label>
          <select
            class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
            v-model="userId"
          >
            <option :value="null">All</option>
            <option
              v-for="stringer in stringers"
              :value="stringer.id"
              v-bind:key="stringer.id"
              >{{ stringer.name }}</option
            >
          </select>
        </div>

        <div class="space-y-1">
          <label
            for="searchText"
            class="block text-sm font-medium text-gray-700"
            >Sort
          </label>
          <select
            class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
            v-model="searchFilter"
          >
            <option value="desc">Newest First</option>
            <option value="asc">Oldest First</option>
          </select>
        </div>
        <div class="space-x-2">
          <button
            class="px-4 py-2 bg-gray-200 rounded-md focus:outline-none"
            v-on:click="resetButtonClick()"
          >
            Reset
          </button>
          <!-- <button
            class="px-4 py-2 bg-blue-600 rounded-md text-white focus:outline-none"
          >
            Search
          </button> -->
        </div>
      </div>
    </div>
    <div
      class="flex-1 z-0 flex flex-col h-full bg-gray-50 overflow-y-auto"
      ref="scrollDiv"
    >
      <main class="flex-1 z-0">
        <div class="mx-auto p-6 container flex-1 flex flex-col space-y-6">
          <div class="w-full">
            <div
              class="grid grid-cols-1 lg:grid-cols-2 gap-4"
              v-if="!searching"
            >
              <div
                class="bg-white rounded-md shadow-md flex flex-row p-2 relative overflow-hidden group select-none"
                v-for="video in videos"
                v-bind:key="video.id"
              >
                <div
                  class="absolute w-full h-full backdrop-filter backdrop-blur-sm z-30 -m-2 opacity-0 group-hover:opacity-100 transition-all flex flex-row content-center justify-center items-center space-x-4"
                >
                  <div
                    class="bg-blue-600 text-white rounded-full w-10 h-10 inline-flex items-center content-center justify-center cursor-pointer hover:bg-blue-500"
                    v-on:click="reprocessYouTube(video.id)"
                    v-if="video.youtube_id == null"
                  >
                    <i class="fa-solid fa-upload"></i>
                  </div>
                  <div
                    class="bg-blue-600 text-white rounded-full w-10 h-10 inline-flex items-center content-center justify-center cursor-pointer hover:bg-blue-500"
                    v-on:click="editVideo(video)"
                  >
                    <i class="fa-solid fa-pen"></i>
                  </div>
                  <div
                    class="bg-blue-600 text-white rounded-full w-10 h-10 inline-flex items-center content-center justify-center cursor-pointer hover:bg-blue-500"
                    v-on:click="downloadVideo(video.id)"
                  >
                    <i class="fa-solid fa-download"></i>
                  </div>
                  <div class="absolute top-0 right-0 ">
                    <i
                      class="fa-solid fa-circle-exclamation text-red-600 mt-3 mr-2 z-50 bg-white rounded-full"
                      :title="'Embargo: ' + video.embargo"
                      v-tippy
                      v-if="video.embargo"
                    ></i>
                  </div>
                </div>
                <div
                  class="flex-none flex flex-col items-center content-center w-48 relative"
                >
                  <div
                    class="absolute top-0 left-0 mt-2 ml-2 bg-blue-500 rounded-md text-white z-20 text-xs px-1.5 py-0.5"
                  >
                    {{ video.length | timecode }}
                  </div>
                  <progressive-img
                    class="rounded-md z-0"
                    style="aspect-ratio: 16 / 9;"
                    fallback="/static/image-unavailable.png"
                    :src="video.thumbnailUrl"
                  />
                  <StarRating
                    class="absolute bottom-0 left-0 mb-1 ml-2 z-20"
                    :id="video.id"
                    :rating="video.rating"
                    v-if="video.rating !== null"
                  />
                </div>
                <div
                  class="flex-1 flex flex-col pl-2 whitespace-nowrap overflow-ellipsis overflow-hidden relative"
                >
                  <p
                    class="whitespace-nowrap overflow-ellipsis overflow-hidden"
                  >
                    <strong class="text-red-600" v-if="video.youtube_id == null"
                      >** YOUTUBE PREVIEW MISSING **</strong
                    >
                    <strong
                      class="text-red-600"
                      v-if="video.status == 'pending'"
                      >PENDING</strong
                    >
                    {{ video.title }}
                  </p>
                  <span v-if="video.status !== 'pending'"
                    >Price: ${{ video.price }}<br
                  /></span>
                  {{ video.created_at | displayLocalDateTime }} <br />
                  Stringer: {{ video.user.name }} <br />
                  <div
                    class="denied-information"
                    style="margin-top: 20px;"
                    v-if="
                      video.status == 'declined' &&
                        video.declined_message !== null
                    "
                  >
                    <strong style="color: red;">This video was denied.</strong>
                    <br />
                    <strong>Reason: </strong>
                    {{ video.declined_message.message }}
                    <br />
                    Declined by {{ video.declined_message.reviewer.name }} at
                    {{
                      video.declined_message.created_at | displayLocalDateTime
                    }}.<br />
                  </div>
                  <div class="absolute top-0 right-0">
                    <i
                      class="fa-solid fa-circle-exclamation text-red-600"
                      v-if="video.embargo"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="mt-4 bg-gray-50 border border-gray-200 flex items-center content-center justify-center py-24"
              v-if="searching"
            >
              <DotPulse />
            </div>
            <div
              class="mt-4 bg-gray-50 border border-gray-200 flex items-center content-center justify-center py-24"
              v-if="!searching && videos.length == 0"
            >
              No videos found for the search criteria.
            </div>
          </div>
          <div
            ref="loadMoreDiv"
            class="h-10 flex items-center content-center justify-center"
          >
            <button
              class="px-3 py-1.5 bg-gray-300 rounded-md focus:outline-none hover:bg-gray-400"
              v-on:click="search"
              v-if="!searching"
            >
              Load more
            </button>
          </div>
        </div>
      </main>
    </div>
    <VideoEditModal />
  </div>
</template>

<script>
import * as Config from "@/config";
import { mapActions } from "vuex";
import moment from "moment";

import StarRating from "@/components/general/StarRating";
import VideoEditModal from "@/screens/admin/modals/VideoEditModal";
import DotPulse from "@/components/Loaders/DotPulse";

export default {
  name: "AdminVideoManager",
  components: {
    StarRating,
    VideoEditModal,
    DotPulse
  },
  data() {
    return {
      videos: [],
      fetching: false,

      resource_url: Config.apiPath + "/api/v2/admin/videos",
      searchQuery: "",
      current_page: 1,
      last_page: null,
      searching: false,
      searchDebounce: null,
      searchFilter: "desc",

      bottom: false,
      interval: null,
      shouldLoadMore: null,
      searchDate: null,
      stringers: [],
      userId: null
    };
  },
  mounted() {
    this.$nextTick(async () => {
      await this.search();
      await this.getStringers();
      this.handleScroll();

      this.$eventBus.$on("scroll", this.bottomVisible);
      this.shouldLoadMore = setInterval(
        function() {
          this.bottomVisible();
        }.bind(this),
        250
      );
    });
  },
  destroyed() {
    this.$eventBus.$off("scroll");
    clearInterval(this.interval);
    clearInterval(this.shouldLoadMore);
  },
  methods: {
    ...mapActions(["addToastMessage"]),
    updateResource(data) {
      this.videos = data;
    },

    async downloadVideo(id) {
      try {
        let res = await this.$http.get(
          Config.apiPath + "/api/v2/admin/videos/" + id + "/download"
        );
        var link = document.createElement("a");
        document.body.appendChild(link);
        link.href = res.data;
        link.click();
        document.body.removeChild(link);

        this.addToastMessage({
          title: "Success",
          text:
            "The file has been successfully requested and is now downloading.",
          type: "success"
        });
      } catch (e) {
        this.addToastMessage({
          title: "Error",
          text:
            "We have encountered an error downloading this video, try again.",
          type: "error"
        });
      }
    },

    editVideo(video) {
      this.$eventBus.$emit("admin-edit-video-open-modal", video);
    },

    async search() {
      let url = this.computeResourceUrl();

      if (this.fetching) return;
      this.fetching = true;
      try {
        let res = await this.$http.get(url);
        this.current_page = res.data.current_page + 1;
        this.videos = this.videos.concat(res.data.data);
        this.searching = false;
        this.fetching = false;
      } catch (e) {
        this.searching = false;
        this.fetching = false;
        this.addToastMessage({
          title: "Error",
          text: "We have encountered an error loading more videos, try again.",
          type: "error"
        });
      }
    },

    async getStringers() {
      let res = await this.$http.get(
        Config.apiPath + "/api/v2/admin/users/stringer_list"
      );
      this.$set(this, "stringers", res.data);
    },

    computeResourceUrl() {
      var baseURL = this.resource_url + "?page=" + this.current_page;

      if (this.searchQuery !== "" && this.searchQuery !== null) {
        baseURL += "&search=" + this.searchQuery;
      }

      if (this.userId !== "" && this.userId !== null) {
        baseURL += "&userId=" + this.userId;
      }

      if (this.searchFilter !== null) {
        baseURL += "&orderBy=" + this.searchFilter;
      }

      return baseURL;
    },
    bottomVisible() {
      const rect = this.$refs.loadMoreDiv.getBoundingClientRect();

      const isInViewport =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth);

      this.bottom = isInViewport;

      return isInViewport;
    },
    reset() {
      this.current_page = 1;
      this.videos = [];
    },
    async resetButtonClick() {
      this.searchQuery = null;
      this.searchFilter = "desc";
      await this.reset();
      await this.search();
    },
    async reprocessYouTube(id) {
      try {
        await this.$http.post(
          Config.apiPath + "/api/v2/admin/videos/" + id + "/youtube_upload"
        );
        this.addToastMessage({
          title: "Success",
          text: "This video was requeued to publish to YouTube.",
          type: "success"
        });
      } catch (e) {
        this.addToastMessage({
          title: "Error",
          text:
            "Encountered an error while attempting to reupload this video to YouTube.",
          type: "error"
        });
      }
    },
    handleScroll() {
      this.bottom = this.bottomVisible();
    }
  },
  watch: {
    searchQuery: function() {
      this.reset();
      this.searching = true;
      clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.search();
      }, 600);
    },
    searchFilter: function() {
      this.reset();
      this.searching = true;
      this.search();
    },
    userId: function() {
      this.reset();
      this.searching = true;
      this.search();
    },
    bottom: function(isAtBottom) {
      if (isAtBottom) {
        this.search();
      }
    }
  },
  filters: {
    timecode: function(value) {
      if (value !== null) {
        var seconds = Math.floor(value % 60).toString();
        var minutes = Math.floor(value / 60).toString();
        if (seconds.length === 1) {
          seconds = "0" + seconds;
        }
        return minutes + ":" + seconds;
      }
    },
    displayLocalDateTime: function(date) {
      return moment
        .utc(date)
        .local()
        .format("MMMM Do YYYY, h:mm a");
    }
  }
};
</script>

<style scoped>
.filter {
  background-color: #fff;
  border-radius: 6px;
  min-height: 20px;
  width: 100%;
  height: auto;
}

.max-w-200 {
  max-width: 200px;
  height: auto;
}
</style>
